import(/* webpackMode: "eager" */ "/vercel/path1/src/app/page.tsx");
